import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getUserId(id:any) {
    return axios.get(API_URL+'/v1/auth0/users/get/'+id)
  }

export function getUserIdglobal(id:any,tenant:number) {
    return axios.get(API_URL+'/v1/auth0/users/get/'+id+'?tenantId='+tenant)
  }

export function getroles() {
    return axios.get(API_URL+'/v1/rol/')
  }

export function getrolesglobal(tenant:number) {
    return axios.get(API_URL+'/v1/rol/?tenantId='+tenant)
  }

export function getmyuser() {
    return axios.get(API_URL+'/v1/auth0/users/get/me')
  }